

import { motion } from "motion/react";
import { Search, X, Users } from "lucide-react";

export const ProblemSection = () => {
  return (
    <section className="py-32 bg-brand-secondary/30 relative overflow-hidden">
      <div className="blob w-96 h-96 bg-brand-accent/20 top-0 left-[20%] blur-[120px]" />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mb-24">
          <motion.h2 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="text-5xl md:text-7xl font-display font-bold mb-8 tracking-tight leading-[1.1]"
          >
            Hiring today is <span className="text-red-500 italic">split</span> between tools and outcomes
          </motion.h2>
          <p className="text-2xl text-gray-500 font-medium italic">You either manage the process yourself, or outsource it without control.</p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12">
          <motion.div 
            whileHover={{ y: -8, scale: 1.02 }}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="p-12 glass rounded-[3rem] glow-border transition-all duration-500"
          >
            <span className="w-12 h-12 rounded-2xl bg-gray-50 flex items-center justify-center mb-8 text-black border border-gray-100 shadow-sm"><Search className="w-6 h-6"/></span>
            <span className="text-brand-accent font-black text-xs uppercase tracking-[0.2em] mb-4 block">Platforms</span>
            <h3 className="text-3xl font-bold mb-8">Platforms give you access. Not results.</h3>
            <ul className="space-y-6">
              {[
                "You get applications, not qualified candidates",
                "Your team still spends hours screening",
                "No accountability for role closure"
              ].map((text, i) => (
                <li key={i} className="flex items-start gap-4 text-gray-500 font-bold leading-tight">
                  <div className="w-6 h-6 rounded-full bg-red-50 flex items-center justify-center shrink-0 mt-0.5"><X className="w-4 h-4 text-red-500" /></div>
                  {text}
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div 
            whileHover={{ y: -8, scale: 1.02 }}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="p-12 glass rounded-[3rem] glow-border transition-all duration-500"
          >
            <div className="w-12 h-12 rounded-2xl bg-gray-50 flex items-center justify-center mb-8 text-black border border-gray-100 shadow-sm"><Users className="w-6 h-6"/></div>
            <span className="text-brand-accent font-black text-xs uppercase tracking-[0.2em] mb-4 block">Agencies</span>
            <h3 className="text-3xl font-bold mb-8">Agencies promise outcomes. But don’t scale.</h3>
            <ul className="space-y-6">
              {[
                "High costs with inconsistent delivery",
                "Limited visibility into the process",
                "Dependent on individual recruiter quality"
              ].map((text, i) => (
                <li key={i} className="flex items-start gap-4 text-gray-500 font-bold leading-tight">
                  <div className="w-6 h-6 rounded-full bg-red-50 flex items-center justify-center shrink-0 mt-0.5"><X className="w-4 h-4 text-red-500" /></div>
                  {text}
                </li>
              ))}
            </ul>
          </motion.div>
        </div>

        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          className="mt-24 text-center p-12 rounded-[2.5rem] bg-brand-primary text-white shadow-2xl relative overflow-hidden"
        >
          <div className="absolute top-0 right-0 p-12 bg-white/5 blur-3xl rounded-full" />
          <p className="text-5xl font-display font-medium tracking-tight h-auto leading-[1.1] mb-2">Hiring shouldn’t be a transition between control and outcomes.</p>
        </motion.div>
      </div>
    </section>
  );
};
